import axios from "axios";
import { useCallback, useRef } from "react";
import { useMsal } from "@azure/msal-react";
import { fetchToken } from "../services/fetchTokenService";
import { getConsumerKey } from "../services/maerskApiTokenService";
import { loginRequest } from "../auth/authConfig";
import SessionValidation from "../context/SessionValidationContext";



export const useFetchWithRetry = () => {
  const { instance, accounts } = useMsal();
  const {setSessionExpired} = SessionValidation()
  const accountsRef = useRef(accounts);
  accountsRef.current = accounts;
  const fetchWithRetry = useCallback(async (url, callingFor, retries = 3, delay = 1000) => {
    // Per-call token: a shared token would let one request cancel unrelated in-flight requests.
    const cancelTokenSource = axios.CancelToken.source();

    try {
      // Keep MSAL session validation
      const tokenResponse = await fetchToken(instance, loginRequest, accountsRef.current);
      if(tokenResponse && tokenResponse.sessionExpired){
        sessionStorage.clear();
        setSessionExpired(true)
      }

      // Use Maersk API token (client-credentials) for API gateway auth
      // const apiToken = await getApiToken();

      const config = {
        headers: {
          Authorization: `Bearer ${tokenResponse.idToken}`,
          "consumer-key": getConsumerKey(),
        },
        cancelToken: cancelTokenSource.token,
      };


      // console.log("TOKENS ", tokenResponse.accessToken, )
      const response = await axios.get(url, config);
      if (response.status === 200 || response.status === 201 || response.status === 202) {
        return response.data;
      } else {
        throw new Error("Unknown error");
      }
    } catch (error) {
      if (axios.isCancel(error)) {
      }
      if (error.response && error.response.status === 401) {
        let forgeRockErrorCode = error.response?.data?.errorcode;
        if(forgeRockErrorCode && forgeRockErrorCode === "steps.jwt.TokenExpired"){
          console.error(forgeRockErrorCode)
        }
        // console.error
        sessionStorage.clear();
        throw error;
      }

      if (retries === 0 || !(error.response && error.response.status === 401)) {
        throw error;
      }

      await new Promise((res) => setTimeout(res, delay));
      return fetchWithRetry(url, callingFor, retries - 1, delay * 2);
    }
  }, [instance, setSessionExpired]);

  return {
    fetchWithRetry,
  };
};
